import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login/admin', {
      username,
      password,
    });
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },
};

